import { GET_INCOME_STATEMENT_DETAILS, GET_MARK_AS_Reviewed_DETAILS, UPDATE_CUSTOM_FILEDS, GET_EDIT_ARCHIED_DATA, GET_MARK_AS_Reviewed_DETAILS_BY_ID } from '../actions/IncomeStatementAction';

const initial_state = {
    IncomeStatementData: null,
    MarkAsReviewedListData: null,
    MarkAsReviewedListDataById: null,
    UpdateData: null,
    EditArchivedData: null
};

export default function authReducer(state = initial_state, action) {
    switch (action.type) {
        case GET_INCOME_STATEMENT_DETAILS:
            return { ...state, IncomeStatementData: action.payload.data };
        case GET_MARK_AS_Reviewed_DETAILS:
            return { ...state, MarkAsReviewedListData: action.payload.data };
        case UPDATE_CUSTOM_FILEDS:
            return { ...state, UpdateData: action.payload.data };
        case GET_EDIT_ARCHIED_DATA:
            return { ...state, EditArchivedData: action.payload.data };
        case GET_MARK_AS_Reviewed_DETAILS_BY_ID:
            return { ...state, MarkAsReviewedListDataById: action.payload.data };
        default:
            return state;
    }
}